import TourConfigBreadcrumbs from '@/features/dashboard/tourConfig/components/TourConfigBreadcrumbs.tsx';
import React, { useEffect } from 'react';
import TourConfigHeader from '@/features/dashboard/tourConfig/components/TourConfigHeader.tsx';
import TourBaseCostConfigCard from '@/features/dashboard/tourConfig/components/TourBaseCostConfigCard.tsx';
import { FormProvider, useForm } from 'react-hook-form';
import {
  BasePriceForm,
  BasePriceInputForm,
  tourPricesSchema,
} from '@/features/dashboard/tourConfig/schemas/tourPricesSchema.ts';
import { debugZodResolver } from '@/lib/debugZodResolver';
import useWriteTourPrices from '@/features/dashboard/tourConfig/hooks/useWriteTourPrices.ts';
import { tourConfigCostsRoute } from '@/features/dashboard/tourConfig/routes/tourConfigRoutes.ts';
import useGetTourPrices from '@/features/dashboard/tourConfig/hooks/useGetTourPrices.ts';
import { tourPriceDtoMapper } from '@/features/dashboard/tourConfig/types/TourPriceDto.mapper.ts';
import { useNavigate } from '@tanstack/react-router';

const TourConfigCostsPage = () => {
  const navigate = useNavigate();
  const { tourId } = tourConfigCostsRoute.useParams();

  const baseCostForm = useForm<BasePriceInputForm>({
    resolver: debugZodResolver(tourPricesSchema),
    mode: 'onChange',
    defaultValues: {
      isPriceByAge: false,
      isVariantOnlyForDefinedAgeRanges: false,
    },
  });

  const { mutate, isPending } = useWriteTourPrices(tourId);

  const onSubmit = async (values: BasePriceForm) => {
    mutate(values, {
      onSuccess: () => {
        navigate({ to: `/app/tours/${tourId}/config/transport` });
      },
    });
  };

  const { data: prices, isPending: tourPricesLoading } =
    useGetTourPrices(tourId);

  useEffect(() => {
    if (tourPricesLoading) return;
    if (prices) {
      const formData = tourPriceDtoMapper.fromDtoToForm(prices);
      if (formData) {
        baseCostForm.reset(formData);
      }
    }
  }, [prices, tourPricesLoading, baseCostForm]);

  return (
    <div className="space-y-4">
      <TourConfigBreadcrumbs />
      <FormProvider {...baseCostForm}>
        <form
          className="flex-1 space-y-4"
          onSubmit={baseCostForm.handleSubmit(onSubmit)}
        >
          <TourConfigHeader
            title="Koszty"
            isLoading={isPending}
            submit={baseCostForm.handleSubmit(onSubmit)}
          />
          <div className="mx-auto max-w-[600px] space-y-2">
            <TourBaseCostConfigCard />
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default TourConfigCostsPage;
